import { Label } from "../../pages/Login/styles";
import { EditContainer } from "./styles";
import { Input, SelectInput } from "../Input/styles";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { MiniErrors } from "../MiniErrors/styles";
import api from "../../services/api";
import { EditAndDeleteBtn } from "../Button/styles";

function EditTechModal({ setUser, user, tec, setIsEdit }) {
  function handleEdit(data) {
    const token = localStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    api
      .put(`/users/techs/${tec.id}`, data, config)
      .then((res) => {
        setIsEdit(false);
        handleRefresh();
      })
      .catch((err) => console.log(err));
  }

  function handleDelete() {
    const token = localStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    api
      .delete(`/users/techs/${tec.id}`, config)
      .then((res) => {
        handleRefresh();
      })
      .catch((err) => console.log(err));
  }
  function handleRefresh() {
    api
      .get(`/users/${user.id}`)
      .then((res) => {
        setIsEdit();
        setUser(res.data);
      })
      .catch((err) => console.log(err));
  }

  const formSchema = yup.object().shape({
    title: yup.string().required("Nome obrigatório").max(20),
    status: yup.string().matches(/^((?!default).)*$/s, "Campo obrigatório"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema),
  });

  const onSubmitFunction = (data) => {
    handleEdit(data);
  };

  return (
    <EditContainer>
      <div
        style={{
          height: "40px",
          backgroundColor: "#343B41",
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
          borderBottom: "1px solid white",
        }}
      >
        <p style={{ fontSize: "17px", fontFamily: "Inter", color: "white" }}>
          Editar Tecnologia
        </p>
        <button
          onClick={() => setIsEdit(false)}
          style={{
            backgroundColor: "transparent",
            border: "0",
            color: "#868E96",
            cursor: "pointer",
          }}
        >
          X
        </button>
      </div>
      <div style={{ heigth: "240px" }}>
        <form
          onSubmit={handleSubmit(onSubmitFunction)}
          style={{
            height: "240px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
            alignItems: "center",
          }}
        >
          <div>
            <Label>
              Nome{" "}
              {errors.title && <MiniErrors> {errors.title.message}</MiniErrors>}
            </Label>
            <Input value={tec.title} {...register("title")} />
          </div>
          <div>
            <Label>
              Selecionar Status{" "}
              {errors.status && (
                <MiniErrors> {errors.status.message}</MiniErrors>
              )}
            </Label>
            <SelectInput defaultValue="default" {...register("status")}>
              <option value="default" disabled>
                Selecionar Status
              </option>
              <option value="Iniciante">Iniciante</option>
              <option value="Intermediário">Intermediário</option>
              <option value="Avançado">Avançado</option>
            </SelectInput>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "95%",
            }}
          >
            <EditAndDeleteBtn
              type="submit"
              border="0"
              backgroundColor="#FF577F"
              fontColor="white"
            >
              Salvar
            </EditAndDeleteBtn>
            <EditAndDeleteBtn
              onClick={() => handleDelete()}
              type="button"
              border="1px solid #FF577F"
              backgroundColor="transparent"
              fontColor="#FF577F"
            >
              Deletar
            </EditAndDeleteBtn>
          </div>
        </form>
      </div>
    </EditContainer>
  );
}

export default EditTechModal;
